import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import SlidingText from '@jimmyboys/liita-ui/dist/components/SlidingText'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import styles from './widgets.module.sass'

export const renderDocuments = (docs, i18n, openFile, setShowDocument) => {
	return docs?.map((doc, index) => {
		return (
			<HStack
				key={index}
				className={styles['file-entry']}
				columns={[3, 1]}
				gap='xsmall'
				justify='space-between'
				align='center'
			>
				<VStack justify='space-evenly'>
					<small>
						<SlidingText>
							<strong>
								{doc.type?.name}{' '}
								{doc.createdAt
									? `(${doc.createdAt?.dateTimeFormat})`
									: null}
							</strong>
						</SlidingText>
					</small>
					<small>
						<SlidingText>{doc.description}</SlidingText>
					</small>

					<div>
						<small className={styles['file-name']}>
							{doc.externalLink && (
								<a
									href={doc.externalLink}
									target='_blank'
									rel='noreferrer'
								>
									<Icon
										className={`${styles['file-icon']} ${styles['--external-url']}`}
										name='x-ray'
										width='14px'
										height='14px'
									/>
								</a>
							)}
							<Icon
								className={styles['file-icon']}
								name='attachment'
								width='14px'
								height='14px'
							/>

							{doc.name}
						</small>
					</div>
				</VStack>
				<ActionButton
					className={styles['document-button']}
					secondary
					onClick={() => {
						openFile && openFile(doc)
						setShowDocument && setShowDocument(false)
					}}
				>
					<small>
						<strong>{i18n`Open`}</strong>
					</small>
				</ActionButton>
			</HStack>
		)
	})
}

const DocumentsWidget = (props) => {
	const { data } = props
	const { documents } = data
	const { i18n, openFile } = useGlobal()

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			title={i18n`Documents`}
			icon='file'
			expanded={false}
			expandable={!!documents?.length}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			{renderDocuments(documents || [], i18n, openFile)}
		</ExpandableWidget>
	)
}

export default DocumentsWidget
